import { requestPost } from '@/common/request';

export interface categoryInventoryListParams {
  activityId: string;
  type?: number;
  searchField?: string;
  currentPage: number;
  pageSize: number;
}

export interface categoryInventoryListRes {
  currentPage: number;
  pageSize: number;
  totalCount: number;
  list:
    | Array<{
        inventoryId: string;
        inventoryName: string;
        creatorErp: string;
        categoryNames: Array<string> | [];
        receivedTime: number;
        subStrategies: Array<{ subStrategyId: string; subStrategyName: string }> | [];
        inventoryRules:
          | Array<{
              subStrategyId: string;
              subStrategyName: string;
              rules: Array<{ ruleName: string; ruleDetails: Array<string> | [] }> | [];
              status: number;
            }>
          | [];
        skuNum: number;
        goodsAmount: number;
        status: number;
      }>
    | [];
}
// 接口文档： https://cf.jd.com/pages/viewpage.action?pageId=1164292866

//品类盘货 - 类目维度盘货列表
export async function categoryInventoryList(
  params: categoryInventoryListParams
): Promise<RequestResult<categoryInventoryListRes>> {
  return await requestPost('/goodsPool/categoryInventoryList', params);
}
